import Vue from 'vue'
import Router from 'vue-router'
import home from '@/view/home'
import Personal from '@/view/Personal'
import Chat from '@/view/Chat'
import ContactPersonInformation from '@/view/ContactPersonInformation'
import ModifyContactPerson from '@/view/ModifyContactPerson'
import login from '@/view/login'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

// Router.beforeEach((to, from, next) => {
//   let token = window.localStorage.getItem('flagMig')
//   if (to.path === '/login') {
//     next()
//   } else {
//     if (token !== null) {
//       next()
//     } else {
//       next('/login')
//     }
//   }
//   next()
// })

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home,
      meta: {title: '首页'}
    },
    {
      path: '/home',
      name: 'home',
      component: home,
      meta: {title: '首页'}
    },
    {
      path: '/Personal',
      name: 'Personal',
      component: Personal,
      meta: {title: '个人中心'}
    },
    {
      path: '/Chat',
      name: 'Chat',
      component: Chat,
      meta: {title: '聊天对话'}
    },
    {
      path: '/ContactPersonInformation',
      name: 'ContactPersonInformation',
      component: ContactPersonInformation,
      meta: {title: '联系人信息'}
    },
    {
      path: '/ModifyContactPerson',
      name: 'ModifyContactPerson',
      component: ModifyContactPerson,
      meta: {title: '编辑'}
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: {title: '登录'}
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js